module.exports = __webpack_public_path__ + "img/758-547040.png";